class FixedHeaderDirective {
    constructor($window, $document, $timeout) {
        this.restrict = 'A';
        this.$window = $window;
        this.$document = $document;
        this.$timeout = $timeout;
    }

    link(scope, element, attrs, controllers) {

        const body = angular.element(this.$document[0].body)

        const recalculate = () => {
            const headerHeight = element[0].offsetHeight;

            if (this.$window.scrollY > headerHeight) {
                element.addClass('fixed');
                body.css({'padding-top': `${headerHeight}px`})
            } else {
                element.removeClass('fixed');
                body.css({'padding-top': ''})
            }
        }

        this.$timeout(() => {
            recalculate();
        }, 1500);

        angular.element(this.$window).on('resize', recalculate);
        angular.element(this.$window).on('scroll', recalculate);

        scope.$on('$destroy', () => {
            angular.element(this.$window).off('resize', recalculate);
            angular.element(this.$window).off('scroll', recalculate);
        });
    }

    static directiveFactory($window, $document, $timeout) {
        'ngInject';
        return new FixedHeaderDirective($window, $document, $timeout);
    }
}

export default FixedHeaderDirective;